import type { TRouteObject } from "@ch/helpers/utils/types";
import ErrorPage from "@ch/pages/ErrorPage";
import ForumsPageLazy from "@ch/pages/ForumsPage";
import NotFoundPage from "@ch/pages/NotFoundPage";

const ForumsRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <ForumsPageLazy />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default ForumsRoutes;
